import type { IconProps } from "../Icon.props";
import createWebIcon from "../createWebIcon";
import validateKeys from "../validateKeys";

export default function Unlock({ outline, ...props }: IconProps): JSX.Element {
  return outline ? <Unlock.Outline {...props} /> : <Unlock.Solid {...props} />;
}

Unlock.Outline = function Outline({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Outline`,
    path: (
      <>
        <path
          d="M12.8628 13.9526C12.8628 13.5384 12.527 13.2026 12.1128 13.2026C11.6986 13.2026 11.3628 13.5384 11.3628 13.9526V16.1746C11.3628 16.5889 11.6986 16.9246 12.1128 16.9246C12.527 16.9246 12.8628 16.5889 12.8628 16.1746V13.9526Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6.80225 7.02775C6.81506 4.10095 9.19754 1.7392 12.1237 1.75004C14.4446 1.75068 16.4148 3.2425 17.133 5.31665C17.2685 5.70807 17.061 6.13523 16.6696 6.27076C16.2782 6.40628 15.851 6.19884 15.7155 5.80742C15.1998 4.31802 13.7847 3.25004 12.1222 3.25004H12.1193C10.0207 3.24169 8.31228 4.93478 8.30225 7.03275V8.37646H15.933C18.4413 8.37646 20.475 10.4104 20.475 12.9195V17.2075C20.475 19.7165 18.4413 21.7505 15.933 21.7505H8.292C5.78366 21.7505 3.75 19.7165 3.75 17.2075V12.9195C3.75 10.9323 5.02555 9.24325 6.80225 8.62649L6.80225 7.02775ZM8.292 9.87646C6.61234 9.87646 5.25 11.2386 5.25 12.9195V17.2075C5.25 18.8884 6.61234 20.2505 8.292 20.2505H15.933C17.6127 20.2505 18.975 18.8884 18.975 17.2075V12.9195C18.975 11.2386 17.6127 9.87646 15.933 9.87646H8.292Z"
          fill="currentColor"
        />
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};

Unlock.Solid = function Solid({ name, ...props }: IconProps) {
  const Icon = createWebIcon({
    ...props,
    name: `${name}Solid`,
    path: (
      <>
        {/**
         * Enter the contents of your SVG here without the <svg> tag.
         * For outlined icons, be sure to add `className="icon-outline"`
         * to each path that needs to be outlined.
         */}
      </>
    ),
  });

  return <Icon {...validateKeys(props)} />;
};
